import React from 'react';
import { useRef } from 'react';
import { Stack } from '../../page-components/ui/Stack.js'
import { InspectorDialog } from "./InspectorDialog.js"
import { useDrag, useDrop } from 'react-dnd'

function InspectorListItems(props) {
    const [editingIndex, setEditingIndex] = React.useState(null)

    const highlightIndex = editingIndex ?? props.highlighIndex

    const children = React.Children.map(props.children, (child, index) => {
        var id = child.key

        var editDialogContent = null
        if (props.editContent) {
            editDialogContent = (
                <InspectorDialog left={-320} width={310} visible={editingIndex == index} onClose={() => {
                    setEditingIndex(null)
                }}>
                    {props.editContent(index)}
                </InspectorDialog>
            )
        }

        return (
            <InspectorListItem highlight={index == highlightIndex} key={index} value={child.props.value} index={index} id={id} onMove={(old, newValue) => {
                if (props.onMove) {
                    props.onMove(old, newValue)
                }
                setEditingIndex(null)
            }} onDelete={() => {
                if (props.onDelete) {
                    props.onDelete(index)
                }
                setEditingIndex(null)
            }} onEdit={() => {
                if (props.editContent) {
                    setEditingIndex(index == highlightIndex ? null : index)
                }

                if (props.onEdit) {
                    props.onEdit(index)
                }
            }} onDragStart={() => {
                if (editingIndex) {
                    setEditingIndex(null)
                }
            }} canEdit={props.editContent || props.onEdit}
            editContent={editDialogContent}
            >                
                {child}
            </InspectorListItem>
        )

    })

    return (
        <div className="inspector-list-items">
            <Stack spacing={10}>
                {children}
            </Stack>
        </div>
    )
}

function InspectorListItem(props) {
    var index = props.index
    var id = props.id
    var move = props.onMove
    var value = props.value
    var highlight = props.highlight

    var className = "inspector-list-item "
    if (highlight) {
        className += " inspector-list-item-highlight"
    }

    const ref = useRef(null)
    const [{ handlerId }, dropRef] = useDrop({
        accept: 'list-item',
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item, monitor) {
            if (!ref.current) {
                return
            }

            const dragIndex = item.index
            const hoverIndex = index
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()
            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }
            // Time to actually perform the action
            move(dragIndex, hoverIndex)
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    })


    const [{ opacity, isDragging }, dragRef, previewRef] = useDrag(
        () => ({
            type: 'list-item',
            item: () => {
                return { id: id, index: index, value: value }
            },
            collect: (monitor) => {
                var item = monitor.getItem()
                return {
                    opacity: item && item.value == value ? 0.1 : 1.0,
                    isDragging: monitor.isDragging(),
                }
            }
        }),
        []
    )

    const opacityy = isDragging ? 1 : 1

    dragRef(dropRef(ref))

    var trash = (
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.49609 2.9043V1.5918C3.49609 1.16992 3.625 0.837891 3.88281 0.595703C4.14453 0.349609 4.5 0.226562 4.94922 0.226562H7.17578C7.625 0.226562 7.97852 0.349609 8.23633 0.595703C8.49805 0.837891 8.62891 1.16992 8.62891 1.5918V2.9043H7.69727V1.65039C7.69727 1.48633 7.64258 1.35352 7.5332 1.25195C7.42773 1.15039 7.28711 1.09961 7.11133 1.09961H5.01367C4.83789 1.09961 4.69531 1.15039 4.58594 1.25195C4.48047 1.35352 4.42773 1.48633 4.42773 1.65039V2.9043H3.49609ZM0.835938 3.37305C0.71875 3.37305 0.615234 3.33008 0.525391 3.24414C0.439453 3.1543 0.396484 3.04883 0.396484 2.92773C0.396484 2.81055 0.439453 2.70898 0.525391 2.62305C0.615234 2.5332 0.71875 2.48828 0.835938 2.48828H11.3066C11.4238 2.48828 11.5254 2.53125 11.6113 2.61719C11.6973 2.70313 11.7402 2.80664 11.7402 2.92773C11.7402 3.04883 11.6973 3.1543 11.6113 3.24414C11.5293 3.33008 11.4277 3.37305 11.3066 3.37305H0.835938ZM3.38477 13.2754C2.96289 13.2754 2.62109 13.1504 2.35938 12.9004C2.10156 12.6543 1.96289 12.3203 1.94336 11.8984L1.52734 3.26172H2.44727L2.86328 11.793C2.87109 11.9648 2.93164 12.1074 3.04492 12.2207C3.1582 12.334 3.29883 12.3906 3.4668 12.3906H8.66406C8.83594 12.3906 8.97852 12.334 9.0918 12.2207C9.20508 12.1113 9.26562 11.9688 9.27344 11.793L9.66602 3.26172H10.6094L10.1992 11.8926C10.1797 12.3145 10.0391 12.6504 9.77734 12.9004C9.51562 13.1504 9.17578 13.2754 8.75781 13.2754H3.38477ZM4.33398 11.3887C4.22461 11.3887 4.13672 11.3574 4.07031 11.2949C4.00391 11.2324 3.96875 11.1484 3.96484 11.043L3.78906 4.7793C3.78516 4.67773 3.81641 4.5957 3.88281 4.5332C3.95312 4.4668 4.04297 4.43359 4.15234 4.43359C4.25781 4.43359 4.34375 4.46484 4.41016 4.52734C4.48047 4.58984 4.51562 4.67188 4.51562 4.77344L4.69727 11.043C4.69727 11.1445 4.66406 11.2285 4.59766 11.2949C4.53125 11.3574 4.44336 11.3887 4.33398 11.3887ZM6.06836 11.3887C5.95898 11.3887 5.86914 11.3574 5.79883 11.2949C5.72852 11.2285 5.69336 11.1445 5.69336 11.043V4.7793C5.69336 4.67773 5.72852 4.5957 5.79883 4.5332C5.86914 4.4668 5.95898 4.43359 6.06836 4.43359C6.18164 4.43359 6.27344 4.4668 6.34375 4.5332C6.41406 4.5957 6.44922 4.67773 6.44922 4.7793V11.043C6.44922 11.1445 6.41406 11.2285 6.34375 11.2949C6.27344 11.3574 6.18164 11.3887 6.06836 11.3887ZM7.80859 11.3887C7.69531 11.3887 7.60547 11.3574 7.53906 11.2949C7.47266 11.2285 7.44141 11.1445 7.44531 11.043L7.62109 4.7793C7.625 4.67383 7.66016 4.58984 7.72656 4.52734C7.79297 4.46484 7.87891 4.43359 7.98438 4.43359C8.09766 4.43359 8.1875 4.4668 8.25391 4.5332C8.32031 4.5957 8.35156 4.67773 8.34766 4.7793L8.17188 11.043C8.16797 11.1484 8.13281 11.2324 8.06641 11.2949C8 11.3574 7.91406 11.3887 7.80859 11.3887Z" fill="#AEAEAE" />
        </svg>
    )

    const drag = (
        <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.899252 6.28125C0.778158 6.28125 0.674643 6.23828 0.588705 6.15234C0.502768 6.0625 0.459799 5.95508 0.459799 5.83008C0.459799 5.70898 0.502768 5.60547 0.588705 5.51953C0.674643 5.43359 0.778158 5.39062 0.899252 5.39062H11.868C11.9891 5.39062 12.0926 5.43359 12.1785 5.51953C12.2684 5.60547 12.3133 5.70898 12.3133 5.83008C12.3133 5.95508 12.2684 6.0625 12.1785 6.15234C12.0926 6.23828 11.9891 6.28125 11.868 6.28125H0.899252ZM0.899252 3.7207C0.778158 3.7207 0.674643 3.67773 0.588705 3.5918C0.502768 3.50586 0.459799 3.40234 0.459799 3.28125C0.459799 3.15625 0.502768 3.05078 0.588705 2.96484C0.674643 2.875 0.778158 2.83008 0.899252 2.83008H11.868C11.9891 2.83008 12.0926 2.875 12.1785 2.96484C12.2684 3.05078 12.3133 3.15625 12.3133 3.28125C12.3133 3.40234 12.2684 3.50586 12.1785 3.5918C12.0926 3.67773 11.9891 3.7207 11.868 3.7207H0.899252ZM0.899252 1.16602C0.778158 1.16602 0.674643 1.12305 0.588705 1.03711C0.502768 0.951172 0.459799 0.847656 0.459799 0.726562C0.459799 0.601562 0.502768 0.496094 0.588705 0.410156C0.674643 0.324219 0.778158 0.28125 0.899252 0.28125H11.868C11.9891 0.28125 12.0926 0.324219 12.1785 0.410156C12.2684 0.496094 12.3133 0.601562 12.3133 0.726562C12.3133 0.847656 12.2684 0.951172 12.1785 1.03711C12.0926 1.12305 11.9891 1.16602 11.868 1.16602H0.899252Z" fill="#AEAEAE" />
        </svg>
    )

    const edit = (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.61084 13.8916C3.0752 13.8916 0.13623 10.9526 0.13623 7.41699C0.13623 3.875 3.06885 0.942383 6.60449 0.942383C10.1465 0.942383 13.0854 3.875 13.0854 7.41699C13.0854 10.9526 10.1528 13.8916 6.61084 13.8916ZM6.61084 12.8125C9.60693 12.8125 12.0063 10.4131 12.0063 7.41699C12.0063 4.4209 9.60059 2.02148 6.60449 2.02148C3.6084 2.02148 1.22168 4.4209 1.22168 7.41699C1.22168 10.4131 3.61475 12.8125 6.61084 12.8125ZM6.55371 5.2207C6.09668 5.2207 5.72852 4.85254 5.72852 4.38916C5.72852 3.92578 6.09668 3.55762 6.55371 3.55762C7.01709 3.55762 7.37891 3.92578 7.37891 4.38916C7.37891 4.85254 7.01709 5.2207 6.55371 5.2207ZM5.5 10.9717C5.23975 10.9717 5.03662 10.7812 5.03662 10.521C5.03662 10.2734 5.23975 10.0767 5.5 10.0767H6.28711V7.16943H5.60791C5.34766 7.16943 5.14453 6.979 5.14453 6.71875C5.14453 6.47119 5.34766 6.27441 5.60791 6.27441H6.80127C7.125 6.27441 7.29639 6.50293 7.29639 6.8457V10.0767H8.0835C8.34375 10.0767 8.54688 10.2734 8.54688 10.521C8.54688 10.7812 8.34375 10.9717 8.0835 10.9717H5.5Z" fill="#AEAEAE"/>
        </svg>

        // <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        //     <path d="M2.31856 12.187L0.739461 12.7954C0.65743 12.8273 0.582235 12.8068 0.513875 12.7339C0.450073 12.6655 0.434123 12.5903 0.466024 12.5083L1.11544 10.9839L8.58028 3.53273L9.77657 4.73585L2.31856 12.187ZM10.3781 4.14796L9.16817 2.94484L9.8586 2.26125C10.0318 2.09263 10.2072 2.00148 10.385 1.98781C10.5673 1.97414 10.7359 2.04477 10.8908 2.19972L11.1233 2.43214C11.2828 2.59165 11.358 2.76027 11.3488 2.938C11.3397 3.11574 11.2463 3.29347 11.0686 3.47121L10.3781 4.14796Z" fill="#AEAEAE" />
        // </svg>
    )

    const editButton = (
        <button key={"edit"} onClick={props.onEdit}>
            {edit}
        </button>
    )

    const trashButton = (
        <button key={"trash"} onClick={props.onDelete}>
            {trash}
        </button>
    )

    const dragHandle = (
        <button onMouseDown={props.onDragStart} key={"drag"} ref={ref} data-handler-id={handlerId} >
            {drag}
        </button>
    )

    var content = props.children
    if (props.canEdit && props.onEdit) {
        content = <div style={{"positionn" : "relative"}}>
            {props.editContent}
            <div onClick={props.onEdit}  style={{'cursor' : 'pointer'}}>
                <div style={{'pointer-events' : 'none'}}>
                {props.children}
                </div>
            </div>
        </div>
    }

    return (
        <div
            ref={previewRef}
            style={{ opacity: opacityy }}
            className={className}>
                    {content} 
                    {trashButton} 
                    {dragHandle}
            </div>
    )
}

export { InspectorListItems }